module.exports = __webpack_public_path__ + "img/will-children.afdf87da.svg";